module.exports = __webpack_public_path__ + "static/media/nbb.7ddab8e2.png";